import { useEffect, useState } from "react";
import type { TrackedOrder } from "../../api/types";
import { useTill } from "../../app/till-context";
import { t } from "../../i18n";
import { Dialog } from "../../ui/Dialog";
import { TrackCard } from "../track/TrackCard";

interface Props {
  /** The order's link for the customer's page. */
  token: string;
  onClose: () => void;
}

/**
 * "Volgpagina klant" on the Koeriers tab (prototype openTrack): the customer's page as the customer
 * sees it after the link in the mail, with the courier on his way.
 */
export function TrackDialog({ token, onClose }: Props) {
  const { api, report } = useTill();
  const text = t.couriers.trackDialog;
  const [order, setOrder] = useState<TrackedOrder | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    api
      .request<{ order: TrackedOrder }>("GET", `/track/${token}`, { retry: true, signal: controller.signal })
      .then((answer) => {
        setOrder(answer.order);
      })
      .catch((error: unknown) => {
        if (!controller.signal.aborted) report(error);
      });
    return () => {
      controller.abort();
    };
  }, [api, report, token]);

  return (
    <Dialog title={text.title} onClose={onClose}>
      <p className="note">{text.note}</p>
      {order === null ? <div className="trackcard" aria-busy="true" /> : <TrackCard order={order} />}
    </Dialog>
  );
}
